<template>
    <!-- Test by test: each result shows exactly what the company will see -->
    <div class="flex flex-col gap-4">
        <div v-for="option in options" :key="option.type" class="flex flex-col gap-2">
            <CFormCheckbox
                :disabled="disabled"
                :model-value="selectedTypes.has(option.type)"
                @update:model-value="toggle(option.type, $event)"
            >
                Zdieľať: {{ option.title }}
            </CFormCheckbox>

            <SharedAssessmentResults :assessments="[option]" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { SharedAssessment } from '#shared/types/JobRequest'
import SharedAssessmentResults from '@/components/jobs/SharedAssessmentResults.vue'

const props = withDefaults(
    defineProps<{
        /** Every result the candidate may share */
        options: SharedAssessment[]
        /** The shared ones, stored as snapshots */
        modelValue: SharedAssessment[]
        disabled?: boolean
    }>(),
    { disabled: false }
)

const emit = defineEmits<{ 'update:modelValue': [value: SharedAssessment[]] }>()

const selectedTypes = computed(() => new Set(props.modelValue.map((assessment) => assessment.type)))

function toggle(type: SharedAssessment['type'], isChecked: boolean) {
    const types = new Set(selectedTypes.value)
    if (isChecked) types.add(type)
    else types.delete(type)

    // Stored as a snapshot of the result, in the same order as the list
    emit(
        'update:modelValue',
        props.options.filter((option) => types.has(option.type))
    )
}
</script>
